'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _AuthBody = require('./AuthBody');

var _AuthBody2 = _interopRequireDefault(_AuthBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AuthEditor(props) {
  var spliter = props.spliter,
      emptyAuth = props.emptyAuth;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'table',
      { className: 'table' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            null,
            'views'
          ),
          _react2.default.createElement(
            'th',
            null,
            '\u8B80\u53D6'
          ),
          _react2.default.createElement(
            'th',
            null,
            '\u65B0\u589E'
          ),
          _react2.default.createElement(
            'th',
            null,
            '\u7DE8\u8F2F'
          ),
          _react2.default.createElement(
            'th',
            null,
            '\u522A\u9664'
          ),
          _react2.default.createElement(
            'th',
            null,
            '\u56DE\u5FA9\u522A\u9664'
          )
        )
      ),
      _react2.default.createElement(_AuthBody2.default, _extends({
        emptyAuth: emptyAuth.views
      }, spliter(props)('views'), {
        actions: ['select', 'insert', 'update', 'remove', 'unremove']
      }))
    ),
    _react2.default.createElement(
      'table',
      { className: 'table' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            null,
            'routes'
          ),
          _react2.default.createElement(
            'th',
            null,
            'get'
          ),
          _react2.default.createElement(
            'th',
            null,
            'post'
          )
        )
      ),
      _react2.default.createElement(_AuthBody2.default, _extends({
        emptyAuth: emptyAuth.routes
      }, spliter(props)('routes'), {
        actions: ['get', 'post']
      }))
    ),
    _react2.default.createElement(
      'table',
      { className: 'table' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            null,
            'prints'
          ),
          _react2.default.createElement(
            'th',
            null,
            'get'
          ),
          _react2.default.createElement(
            'th',
            null,
            'post'
          )
        )
      ),
      _react2.default.createElement(_AuthBody2.default, _extends({
        emptyAuth: emptyAuth.prints
      }, spliter(props)('prints'), {
        actions: ['get', 'post']
      }))
    ),
    _react2.default.createElement(
      'table',
      { className: 'table' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            null,
            'streams'
          ),
          _react2.default.createElement(
            'th',
            null,
            'get'
          ),
          _react2.default.createElement(
            'th',
            null,
            'post'
          )
        )
      ),
      _react2.default.createElement(_AuthBody2.default, _extends({
        emptyAuth: emptyAuth.streams
      }, spliter(props)('streams'), {
        actions: ['get', 'post']
      }))
    )
  );
}
AuthEditor.propTypes = {
  schema: _propTypes.object.isRequired,
  spliter: _propTypes.func.isRequired,
  emptyAuth: _propTypes.object.isRequired
};
exports.default = AuthEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/AuthEditor/AuthEditor.js
// module id = 1781
// module chunks = 0